import { isValidPhoneNumber } from 'react-phone-number-input'
import { hasDuplicateStrings } from 'src/consumer/helpers/utilFunctions'

export function isValidEmail(email) {
  if (!email || typeof email !== 'string') {
    return false
  }
  // Comprehensive email validation with support for modern TLDs including .health, .ai, .io, etc.
  // Updated to support TLDs from 2 to 63 characters (ICANN standard)
  const emailRegex = /^[a-zA-Z0-9]([a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9]([a-zA-Z0-9.-]*[a-zA-Z0-9])?\.[a-zA-Z]{2,63}$/
  return emailRegex.test(email.trim())
}
export function isValidMobile(mobile) {
  const phoneRegex = /^\+?[0-9]{10,15}$/
  return phoneRegex.test(mobile)
}

export function isProspectEmailValid(emailString) {
  if (!emailString) {
    return false
  }
  if (!isValidEmail(emailString)) {
    return false
  }
  return true
}

export function isProspectMobileValid(emailString) {
  if (!emailString) {
    return false
  }
  if (!isValidPhoneNumber(emailString)) {
    return false
  }
  return true
}

export function isProspectValid(prospects, currentProspect) {
  const allEmailsInProspects = prospects?.map((prospect) => {
    return prospect?.email
  })

  const allMobilesInProspects = prospects?.map((prospect) => {
    return prospect?.mobile
  })

  const prospectEmail = currentProspect?.email
  const prospectMobile = currentProspect?.mobile

  //email validitiy
  if (!isProspectEmailValid(prospectEmail)) {
    return false
  }
  if (hasDuplicateStrings(allEmailsInProspects)) {
    return false
  }

  //mobile validitiy
  if (!isProspectMobileValid(prospectMobile)) {
    return false
  }
  // if (hasDuplicateStrings(allEmailsInProspects)) {
  //   return false
  // }

  return true
}
